<template>
  <div class="cp-product-detail-view">
    <div v-if="product" class="cp-product-detail-view-container columns is-multiline is-mobile">
        <div class="column is-12-mobile is-5-tablet is-5-desktop">
          <div class="columns is-centered is-multiline is-mobile">
            <div class="column is-12-mobile is-12-tablet is-12-desktop">
              <p
                :class="['cp-product-detail-view-product-name']"
                class="title is-3 is-hidden-tablet has-text-left has-text-black"
              >
                {{ product.product_name_localized }}
              </p>
              <img class="cp-product-detail-view-primary-image" :src="primaryImage" />
              <!-- <img class="cp-product-detail-view-primary-image" :src="selectedImage" /> -->
            </div>
            <div
              v-for="image in product.product_image"
              :key="image"
              class="column is-3-mobile is-3-tablet is-3-desktop is-2-widescreen"
            >
              <div
                class="cp-product-detail-view-secondary-image-placeholder"
                @click="selectPrimaryImage(image)"
              >
                <img class="cp-product-detail-view-secondary-image" :src="image" />
              </div>
            </div>
            <div class="cp-product-detail-view-hr is-hidden-tablet" />
          </div>
        </div>
        <div class="column is-12-mobile is-7-tablet is-7-desktop">
          <p
            :class="['cp-product-detail-view-product-name']"
            class="title is-3 is-hidden-mobile has-text-link has-text-left"
          >
            {{ product.product_name_localized }}
          </p>

          <!-- <div class="cp-product-detail-view-price-section">
            <p
              class="cp-product-detail-view-discount is-italic
              has-text-weight-bold has-text-danger "
              v-if="product.is_discount === 'yes'"
            >
              ฿{{ product.discount | formatComma }}.-
            </p>
            <p
              class="cp-product-detail-view-price is-italic has-text-weight-bold"
              :class="[
                product.is_discount === 'yes'
                  ? 'cp-product-detail-view-price-with-discount has-text-grey-light'
                  : 'has-text-primary',
              ]"
            >
              ฿{{ product.price | formatComma }}.-
            </p>
          </div> -->

          <Reader
            class="cp-product-detail-view-content"
            :content="product.product_information_localized"
          />

          <div class="has-text-centered md-button-section">
            <div class="is-inline-block-tablet">
              <span
                class="has-text-black"
                @click="gotoAddToCart(product)"
                ><img src="https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-17_nbhmu6Zn68k.png"
                  class="md-button-white"
                  />
                </span
              >
            </div>
            <div class="md-button-section-compare">
              <span
                class="has-text-black"
                @click="openModal()"
              >
                <img src="https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-18_ZEkz2xc126G.png"
                  class="md-button-white"
                  />
              </span>
            </div>
            <!-- <div class="is-inline-block-tablet">
              <b-button class="cp-product-detail-view-button" rounded outlined
                >{{ $t('products.fda.label') }} {{ product.fda_number }}</b-button
              >
            </div> -->
          </div>
        </div>
        <!-- <img src="../../assets/img/product/product-detail-bg.png" class="section-img-bg"> -->
      <!-- <ShadowDivider />
      <StandardSection class="cp-product-detail-view-standard-section" />
      <ShadowDivider class="cp-product-detail-view-bottom-divider" :upside="true" /> -->

      <XContainer class="cp-product-detail-view-bottom-section has-background-white">
        <img src="https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-16_I0gsbj_HbeP.jpg"
            class="section-img-bg is-hidden-touch"
        />
        <img src="https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-30_RFJ2KiPal.jpg"
            class="section-img-bg is-hidden-desktop"
        />
        <div class="test-center">
        <p class="has-text-weight-bold has-text-black is-size-3 has-text-centered">
          <!-- {{ $t('products.related.products.label') }} -->
          OTHER PRODUCTS
        </p>
        <p
          v-if="relatedProducts.length === 0"
          :class="['has-text-weight-bold', 'has-text-grey', 'is-size-5', 'has-text-centered']"
          class="cp-product-detail-view-no-related-product"
        >
          {{ $t('products.no.related.products.label') }}
        </p>
        <!-- Mobile Version -->
          <!-- <b-carousel-list
            v-model="values"
            :data="items"
            :arrow="arrow"
            :arrow-hover="arrowHover"
            :items-to-show="perList"
            :items-to-list="increment"
            :repeat="repeat"
            :has-drag="drag"
            :has-grayscale="gray"
            :has-opacity="opacity" /> -->
        <!-- Mobile version -->
         <b-carousel-list
            :data="relatedProducts"
            :items-to-show="4"
            class="has-text-centered-wk move-right-position is-hidden-touch"
            :autoplay="true"
        >
            <template slot="item" slot-scope="list"
              class="mb-product"
            >
               <Product
                  :otproduct="true"
                  :image="list.list.product_image.length ? list.list.product_image[0] : ''"
                  :title="list.list.product_name_localized"
                  :detail="list.list.product_description_localized"
                  :sale="list.list.is_discount === 'yes'"
                  :price="list.list.price"
                  :discount="list.list.discount"
                  @click="goToProductDetail(list.list.id)"
                />
            </template>
        </b-carousel-list>
        <!-- Desktop version -->
         <b-carousel-list
            :data="showRelatedProducts"
            :items-to-show="2"
            class="has-text-centered-wk move-right-position is-hidden-desktop"
            :autoplay="true"
        >
            <template slot="item" slot-scope="list"
              class="mb-product"
            >
               <Product
                  :otproduct="true"
                  :image="list.list.product_image.length ? list.list.product_image[0] : ''"
                  :title="list.list.product_name_localized"
                  :detail="list.list.product_description_localized"
                  :sale="list.list.is_discount === 'yes'"
                  :price="list.list.price"
                  :discount="list.list.discount"
                  @click="goToProductDetail(list.list.id)"
                />
            </template>
        </b-carousel-list>
        </div>
        <!-- Desktop Version -->
        <!-- <div
          class="cp-product-detail-view-related-products
          columns is-multiline is-mobile is-centered is-hidden-touch"
        >
          <div
            class="column is-6-mobile is-6-tablet is-3-desktop"
            :key="index"
            v-for="(product, index) in relatedProducts"
          >
            <Product
              class="cp-product-detail-view-product-item has-text-centered"
              :image="product.product_image.length ? product.product_image[0] : ''"
              :title="product.product_name_localized"
              :detail="product.product_description_localized"
              :sale="product.is_discount === 'yes'"
              :price="product.price"
              :discount="product.discount"
              @click="goToProductDetail(product.id)"
            />
          </div>
        </div> -->
      </XContainer>
      <ProductCompareModal/>
    </div>
      <b-modal v-model="isCompareModalActive"
        :active="isCompareModalActive"
        :destroy-on-hide="false"
        :can-cancel="false"
        >
            <div class="container md-white-bg">
            <h3 class="has-text-left compare-section-title">
              COMPARE
            </h3>
            <div class="container compare-section">
                <div class="columns ">
                  <div class="column is-5-desktop is-12-mobile selected-img">
                    <img :src="primaryImage">
                  </div>
                  <div class="column is-1-desktop has-text-centered ">
                    <img src="../../assets/img/product/product-compare-1.png"
                    width="90%"
                    class="is-hidden-touch"
                    >
                  </div>
                  <div class="column is-6-desktop is-12-mobile">
                    <div class="columns is-multiline is-mobile auto-scroll">
                      <div
                        v-for="(product, related_index) in compareProductShow"
                        :key="related_index"
                        @click="selectCompare(product,related_index)"
                        class="column is-4-mobile is-6-tablet is-4-desktop compareSection">
                          <img :src="product.product_image[0]" class="md-modal-img">
                        <div class="overlay overlayFade"
                        :class="{ 'activeSelect': activeIndex === related_index}"
                        >
                           <img
                              src="https://ik.imagekit.io/osusf6xvdf/beta/Madam_Ranee_Website_Export-52_PNdNBtYaIcb.png"
                              >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="has-text-centered md-modal-footer">
                  <b-button
                      class="has-text-black is-12-mobile md-modal-footer-button-bg"
                      @click="gotoCompare()"
                      >
                  </b-button>
                  <b-button
                      class="has-text-black is-12-mobile md-modal-footer-button-white"
                      @click="openModal()"
                    >
                  </b-button>
                </div>
            </div>
            </div>
      </b-modal>
      <OrderFloatIcon />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getProduct, getRelatedProducts, getProducts } from '@/apis/product';
// import { getProduct, getRelatedProducts, viewProduct } from '@/apis/product';
import Product from '@/components/Product.vue';
// import ShadowDivider from '@/components/ShadowDivider.vue';
// import StandardSection from '@/components/StandardSection.vue';
import XContainer from '@/components/XContainer.vue';
import Reader from '@/components/Quill/Reader.vue';
import ProductCompareModal from '@/components/ProductCompareModal.vue';
import swal from 'sweetalert';
import OrderFloatIcon from '@/components/OrderFloatIcon.vue';

export default {
  name: 'ProductDetailView',
  components: {
    Reader,
    // StandardSection,
    // ShadowDivider,
    Product,
    XContainer,
    ProductCompareModal,
    OrderFloatIcon,
  },
  filters: {
    formatComma(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    removeCurrentProduct(item) {
      return item;
    },
  },
  data() {
    return {
      products: [],
      product: null,
      currentProduct: null,
      relatedProducts: [],
      relatedProductsTemp: [],
      compareProductData: [],
      compareProductShow: [],
      productCart: [],
      selectedImage: '',
      isCompareModalActive: false,
      activeIndex: undefined
    };
  },
  created() {
    this.productCart = this.ProductCart;
  },
  watch: {
    $route: 'fetchData',
  },
  async mounted() {
    await this.fetchData();
  },
  computed: mapState({
    ProductCart: state => state.productCart,
    primaryImage() {
      if (this.selectedImage) {
        return this.selectedImage;
      }
      if (!this.product) {
        return '';
      }
      if (this.product.product_image.length) {
        return this.product.product_image[0];
      }
      return '';
    },
    showRelatedProducts() {
      const tempRelateIndex = this.relatedProducts.findIndex(i => i.id === this.product.id);
      this.relatedProductsTemp = this.relatedProducts;
      this.relatedProductsTemp.splice(tempRelateIndex, 1);
      return this.relatedProductsTemp;
    }
  }),
  beforeRouteLeave(to, from, next) {
    this.$store.commit('updateCurrentProductName', '');
    next();
  },
  methods: {
    async fetchData() {
      this.product = await getProduct(this.$route.params.id);
      // const { products, total } = await getProducts(this.currPage, this.pageSize);
      // this.products = products;
      const { products } = await getProducts(1, 100);
      this.products = products;
      this.findCompareDataShow();
      this.$store.commit('updateCurrentProductName', this.product.product_name_localized);
      this.relatedProducts = await getRelatedProducts(this.product.category_id, this.product.id);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    findCompareDataShow() {
      const tempIndex = this.products.findIndex(i => i.id === this.product.id);
      this.compareProductShow = this.products;
      this.compareProductShow.splice(tempIndex, 1);
      // console.log(this.products);
      // this.compareProductShow = this.products.splice(tempIndex, 1);
      // console.log(this.products);
    },
    selectPrimaryImage(image) {
      this.selectedImage = image;
    },
    goToProductDetail(id) {
      if (id.toString() === this.$route.params.id.toString()) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      this.selectedImage = '';
      this.$router.push({
        name: 'ProductDetail',
        params: {
          id,
        },
      });
      // this.selectPrimaryImage(this.product.product_image[0]);
    },
    openModal() {
      this.isCompareModalActive = !this.isCompareModalActive;
    },
    returnone() {
      return 1;
    },
    gotoAddToCart(x) {
      const tempNum = this.productCart.findIndex(i => i.id === x.id);
      if (tempNum === -1) {
        const tempValue = x;
        tempValue.amount = 1;
        this.productCart.push(tempValue);
      } else {
        this.productCart[tempNum].amount += 1;
      }
      console.log(this.productCart);
      this.$store.commit('updateproductCart',
        this.productCart);
      swal({
        title: 'Add to cart',
        icon: 'success',
        button: 'Done',
      });
    },
    gotoCompare() {
      this.compareProductData = [];
      this.compareProductData.push(this.product);
      this.compareProductData.push(this.currentProduct);
      this.$router.push({
        name: 'ProductCompareView',
        params: {
          compareProduct: this.compareProductData
        },
      });
    },
    selectCompare(product, relatedIndex) {
      this.currentProduct = product;
      this.activeIndex = relatedIndex;
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.auto-scroll{
  max-height:420px;
  overflow: auto;
}
.compare-section{
  padding: 4%;
}
.selected-img{
  border: 1px solid lightgrey;
}
.test-center{
  margin-top: -35%;
  @media screen and (max-width: 768px) {
      margin-top: -140%;
      margin-bottom: 20%;
  }
}
.modal-close{
  display: none !important;
}
.carousel-list.has-shadow {
    box-shadow: 0px 0px 0px rgba(255, 255, 255, 1) !important;
}
.has-text-centered-wk{
  text-align: -webkit-center !important;
  margin-top: -70px;
  margin-bottom: -110px;
  @media screen and (max-width: 768px) {
      margin-top: 0px;
      margin-bottom: -110px;
  }
}
.md-button-section{
  // margin-top:3rem;
  &-compare{
    margin-top: -30px;
  }
}
.mb-product{
  margin-right:20px;
}
.cp-article-detail-view {
  &-horizontal-list-container {
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    overflow-x: auto;
    width: 100%;
    height: 380px;
  }
  &-item {
    flex-shrink: 0;
  }

  &-item:first-child {
    margin-left: auto;
  }

  &-item:last-child {
    margin-right: auto;
  }
}
.compareSection{
  position: relative;
}
.overlay {
 position: absolute;
 transition: all 0.3s ease;
 opacity: 0;
 background-color: black;
 cursor: pointer;
}
.compareSection:hover .overlay{
 opacity: 0.7;
}
.overlayFade {
    /* height: 50%; */
    width: 69%;
    top: 0;
    left: 0;
    background-color: black;
    margin-top: 8%;
    margin-left: 15.5%;
    cursor: pointer;
    @media screen and (max-width: 768px) {
      width: 85%;
      top: 0;
      left: 0;
      background-color: black;
      margin-top: 10%;
      margin-left: 12%;
    }
}
.move-right-position div{
  // right: 80px;
}
.md-compare-section{
  margin-bottom:-30%;
}
.compareSelect{
  opacity: 0;
  position: absolute;
  width: 100px;
  height: 100px;
  text-align: center;
  top: 10px;
  cursor: pointer;
   @media screen and (max-width: 900px) {
     opacity: 0;
     position: relative;
     width: 100px;
     height: 100px;
     text-align: center;
     top: -55% !important;
     cursor: pointer;
   }
}
.activeSelect{
  opacity: 0.8 !important;
}
.modal-close{
  display: none;
}
.compare-section-title{
  font-size: 30px;
}
.is-large.modal-close{
  display: none;
}
.md-modal-img{
    display: block;
    // margin-bottom: 20px;
    margin-left: auto;
    margin-right: auto;
    width: 100px;
    height: 100px;
    cursor: pointer;
    border: 1px solid lightgrey;
}

.md-white-bg{
  background: white;
  background-size: 100%;
  padding: 30px;
  border-radius: 10px;
}

.section-img-bg{
    z-index:-1;
    // margin-top:-40%;
}
.section-1-bg{
  background: ur("../../assets/img/product/product-detail-bg.png");
  background-position: center;
  background-size: auto;
}
.md-modal-footer{
  &-button-bg{
    padding: 5px 100px 5px 100px;
    margin-right: 20px;
    background: url("https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-19_M-08XVckoFV.png");
    background-position: center;
    margin-top:20px;
     @media screen and (max-width: 900px) {
      margin-right: 0px;
     }
  }
  &-button-white{
    padding: 5px 100px 5px 100px;
    background-position: center;
    background: url("https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-20_jyCMlwDCECdl.png");
    background-position: center;
    margin-top:20px;
  }
}
.md-button{

  &-bg{
    padding: 10px 80px 10px 80px;
    background: url("../../assets/img/home/button-menu-active.png");
    background-position: center;
      @media screen and (max-width: 768px) {
      width:80%  !important;
      height:3rem;
    }
  }

  &-white{
    // margin-top:2rem;
    padding: 10px 98px 10px 98px;
    background-position: center;
    height: 90px;
    cursor: pointer;
    @media screen and (max-width: 768px) {
      // width:80%  !important;
      height:3rem;
      padding:0px;
      margin-bottom: 20px;
    }
  }
}
.cp-product-detail-view {
  padding-top: 40px;
  &-button{
    margin-top:20px;
  }
  &-container {
    padding: 10px;
  }

  &-primary-image {
    display: block;
    max-height: 400px;
    height: 400px;
    margin-left: auto;
    margin-right: auto;
  }

  &-secondary-image-placeholder {
    cursor: pointer;
    display: block;
    margin-left: auto;
    margin-right: auto;
    // border: 1px solid #80808045;
    // height: 100px;
    width: 150%;
    max-width: 100px;
  }

  &-secondary-image {
    // max-height: 100px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  &-content {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }

  &-product-name {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 10px;
    border-bottom: 1px solid $primary;
  }

  &-hr {
    width: 80%;
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
    border-bottom: 1px solid $primary;
  }

  &-price-section {
    width: 80%;
    display: flex;
    margin-left: auto;
    margin-right: auto;
  }

  &-discount {
    margin-right: 10px;
  }

  &-price-with-discount {
    position: relative;

    &::before {
      position: absolute;
      content: '';
      left: 0;
      top: 50%;
      right: 0;
      border-top: 1px solid;
      border-color: inherit;

      transform: rotate(-5deg);
    }
  }

  &-button {
    margin-top: 15px;
    height: 50px;
    width: 300px;
    max-width: 80%;
  }

  &-bottom-section {
    position: relative;
    width: 100%;
    padding-top: 20px;
    padding-bottom: 50px;
    // background:url('https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-16_I0gsbj_HbeP.jpg');
    // background-size:cover;
  }

  &-related-products {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }

  &-product-item {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  &-standard-section {
    margin-top: 40px;
  }

  &-bottom-divider {
    bottom: -40px;
  }

  &-no-related-product {
    margin-top: 40px;
    margin-bottom: 40px;
  }
}
</style>
